module.exports = __webpack_public_path__ + "static/media/skyelar.62f57eaa.png";